import { Button, Nav, Navbar, Overlay, Popover } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useRef, useState } from "react";
import { useAuth } from "../context/AuthContext";

interface Props {
    subtitle?: string | null;
}

export function TopographNavbar({ subtitle = null }: Props) {
    const navigate = useNavigate();
    const auth = useAuth();
    const [popoverOpen, setPopoverOpen] = useState(false);
    const acctBtnRef = useRef<HTMLButtonElement | null>(null);

    return (
        <Navbar bg="dark" data-bs-theme="dark" style={{ color: "#FFBF00" }}>
            <div className="container-fluid">
                <img
                    src="/map.svg"
                    alt="topograph"
                    style={{ height: "2rem", cursor: "pointer" }}
                    onClick={() => navigate("/")}
                />
                {subtitle !== null && <small>&nbsp;&nbsp;{subtitle}</small>}

                <Nav className="ms-auto align-items-center">
                    <Nav.Link href="/create">
                        <i className="bi bi-house-add" />&nbsp;Create
                    </Nav.Link>
                    <Nav.Link href="/renders">
                        <i className="bi bi-files" />&nbsp;Renders
                    </Nav.Link>
                    <Nav.Link href="/orders">
                        <i className="bi bi-bag-check" />&nbsp;Orders
                    </Nav.Link>
                    {(auth.scopes.includes("topograph.admin") ||
                        auth.scopes.includes("authz.admin")) && (
                        <Nav.Link href="/admin">
                            <i className="bi bi-shield-lock" />&nbsp;Admin
                        </Nav.Link>
                    )}
                    {auth.loggedIn ? (
                        <>
                            <Button
                                ref={acctBtnRef}
                                variant="outline-warning"
                                onClick={() => setPopoverOpen((v) => !v)}
                            >
                                <i className="bi bi-person" />
                            </Button>
                            <Overlay
                                target={acctBtnRef.current}
                                show={popoverOpen}
                                placement="bottom-end"
                                rootClose
                                onHide={() => setPopoverOpen(false)}
                            >
                                <Popover>
                                    <Popover.Header>Account Info</Popover.Header>
                                    <Popover.Body>
                                        {auth.name && <>{auth.name}<br /></>}
                                        {auth.email}<br />
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={async () => {
                                                await auth.logout();
                                                setPopoverOpen(false);
                                            }}
                                        >
                                            <i className="bi bi-box-arrow-right" /> Log Out
                                        </Button>
                                    </Popover.Body>
                                </Popover>
                            </Overlay>
                        </>
                    ) : (
                        <Button
                            variant="outline-warning"
                            disabled={auth.loading}
                            onClick={() => auth.login()}
                        >
                            <i className="bi bi-box-arrow-in-right" />&nbsp;Sign In
                        </Button>
                    )}
                </Nav>
            </div>
        </Navbar>
    );
}
